module.exports = __webpack_public_path__ + "img/shebeiguanliB.0823eef4.png";